import { render, staticRenderFns } from "./CustomerDownloadsCard.vue?vue&type=template&id=43ab74df&scoped=true"
import script from "./CustomerDownloadsCard.vue?vue&type=script&lang=js"
export * from "./CustomerDownloadsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab74df",
  null
  
)

export default component.exports